<template>
  <div>
    <CForm @submit.prevent="submit">
      <CModal
        centered
        :close-on-backdrop="false"
        :show.sync="properties.visible"
      >
        <ValidationObserver ref="observer">
          <ValidationProvider
            v-slot="{ errors }"
            name="videoUrl"
            rules="required|min:1|max:100"
          >
            <CInput
              label="영상주소"
              placeholder="영상주소를 입력하세요"
              autocomplete="videoUrl"
              horizontal
              v-model="form.videoUrl"
              :invalid-feedback="errors.length > 0 ? errors[0] : ''"
              :is-valid="errors.length > 0 ? false : null"
            >
            </CInput>
          </ValidationProvider>
        </ValidationObserver>

        <template #header>
          <h5 class="modal-title" v-if="properties.params.type === 'add'">
            영상정보 추가
          </h5>
          <h5 class="modal-title" v-if="properties.params.type === 'edit'">
            영상정보 수정
          </h5>
          <CButtonClose @click="properties.visible = false"></CButtonClose>
        </template>
        <template #footer>
          <CButton @click="properties.visible = false" color="secondary">
            취소
          </CButton>
          <CButton type="submit" color="success"> 저장</CButton>
        </template>
      </CModal>
    </CForm>
  </div>
</template>

<script>
import {
  extend,
  localize,
  ValidationObserver,
  ValidationProvider,
} from "vee-validate";
import MixinsModalBackButton from "@/mixins/modal-back-button";
import { max, min, required } from "vee-validate/dist/rules";
import Constant from "@/store/constant";
import core from "@/core";
import FacilityVideoService from "@/services/facility/facility-video.service";
import store from "@/store";

extend("required", required);
extend("min", min);
extend("max", max);

localize("ko", {
  messages: Constant.validate.language.korea.messages,
  names: {
    videoUrl: "영상주소",
  },
});

export default {
  name: "AddEditInEnvVideoModal",
  mixins: [MixinsModalBackButton()],
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  props: {
    properties: {
      type: Object,
      default: () => {
        return {
          visible: false,
          params: {},
          watchClose: {
            result: "",
            item: null,
          },
        };
      },
    },
  },
  data() {
    return {
      app: store.state.app,
      form: {
        videoUrl: "",
      },
    };
  },
  created() {
    if (this.properties.params.type === "edit") {
      this.form.videoUrl = this.properties.params.item.videoUrl;
    }
  },
  computed: {},
  watch: {
    "form.videoUrl"() {
      this.changeValue();
    },
  },
  methods: {
    changeValue(changed) {
      const $this = this;
      if (changed != null) {
        $this.backButton.changed = changed;
      } else {
        $this.backButton.changed = true;
      }
    },
    async submit() {
      const observer = this.$refs.observer;
      const isValid = await observer.validate();
      if (isValid) {
        core.loader.show();
        const params = core.utils.deepCopy(this.form);
        try {
          let result = null;
          if (this.properties.params.type === "add") {
            result = await FacilityVideoService.create(
              this.app.facilityId,
              params,
            );
          }
          else {
            result = await FacilityVideoService.update(
              this.app.facilityId,
              this.properties.params.item.id,
              params,
            );
          }
          console.log("result : ", result);
          this.properties.watchClose = {
            result: "confirm",
          };
          this.properties.visible = false;
        } catch (e) {
          console.log("error : ", e);
          const errorFieldName = e.errorFieldName;
          if (errorFieldName != null) {
            const errors = observer.errors[errorFieldName];
            if (errors != null) {
              errors.push(e.message);
            } else {
              console.log(`not found error field '${errorFieldName}'`);
            }
            console.log(observer.errors);
          }
        }
        core.loader.hide();
      } else {
        console.log("errors : ", observer.errors);
      }
    },
  },
};
</script>
